export default "/images/co-img-2.png?44132ba60a09e049fbaf354db775cbbd";